import React from "react";
function Footer() {
    return ( 
        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
            <div className="row">
                <div className="col mt-2">
                    <img src='media/images/logo.svg' alt='Zerodha Logo' style={{ width: "150px", marginTop: "20px" }} />
                    <p className="mt-3">© 2024 Zerodha Broking Limited. All rights reserved.</p>
                    <i class="fa-brands fa-facebook fa-2x me-3"></i>
                    <i class="fa-brands fa-twitter fa-2x me-3"></i>
                    <i class="fa-brands fa-linkedin fa-2x me-3"></i>
                    <i class="fa-brands fa-instagram fa-2x me-3"></i>
                    <i class="fa-brands fa-youtube fa-2x me-3"></i>
                </div>
                <div className="col">
                    <h4 className="mt-4">Company</h4>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>About</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Products</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Pricing</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Referral programme</a><br></br> 
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Careers</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Zerodha.tech</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Press&media</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Zerodha cares (CSR)</a><br></br>

                </div>
                <div className="col">
                    <h4 className="mt-4">Support</h4>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Contact</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Support portal</a>  <br></br> 
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Z-Connect blog</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>List of charges</a><br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Downloads & resources</a><br></br>
                </div>
                <div className="col">
                    <h4 className="mt-4">Account</h4>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>Open an account</a><br></br>
                    <a href="#"style={{textDecoration:"None",color:"black"}}>Fund account</a>   <br></br>
                    <a href="#" style={{textDecoration:"None",color:"black"}}>60 day challenge</a><br></br>
                </div>
            </div>
            <div className="row mt-4 text-muted">
                <p>
                    Zerodha Broking Ltd.: Member of NSE & BSE - SEBI Registration no.: INZ000031633 CDSL: Depository services through Zerodha Securities Pvt. Ltd. SEBI Registration Trading through Zerodha Commodities Pvt. Ltd. MCX: 46025-SEBI Registration no.: INZ000038238 Registered Address: Zerodha Broking Ltd., #153/154, 4th Cross School, J.P Nagar 4th Phase, Bengaluru 560078, Karnataka, India. For any complaints pertaining to securities broking please write to complaints@zerodha.com, for investment ensure you carefully read the Risk Disclosure Document as prescribed by SEBI | ICF
                </p>
                <p>
                    Procedure to file a complaint on SEBI SCORES: Register on SCORES portal. Mandatory details for filing complaints on SCORES: Name, PAN, Address, Mobile Number Communication, Speedy redressal of the grievances
Investments in securities market are subject to market risks; read all the related documents carefully before investing.
                </p>
            </div>
        </div>
      );
}

export default Footer;